var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_39700",
    "data-name": "Group 39700",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14827",
    "data-name": "Rectangle 14827",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plus",
    d: "M13.3,6.3H7.7V.7A.7.7,0,0,0,6.3.7V6.3H.7a.7.7,0,0,0,0,1.4H6.3v5.6a.7.7,0,1,0,1.4,0V7.7h5.6a.7.7,0,1,0,0-1.4Zm0,0",
    transform: "translate(1 1)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f6f928e5de5b77583d14d7b0830028b1.svg";
export { ForwardRef as ReactComponent };